<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      max-width="650px"
      :persistent="true"
    >
      <v-card>
        <v-card-title>
          <span style="font-weight: bold; font-size: 24px;">{{ header }}</span>
        </v-card-title>
        <v-card-text>
          <div style="font-size: 18px;">{{ title }}</div>
          <br/>
          <div style="font-size: 16px;" :class="`message-${confirmationType}`">
              {{ messagePrefix }}{{ message }}

          </div>
          <div v-if="withReason">
            <v-form
              ref="form"
            >
              <v-text-field
                  v-model="reason"
                  :rules="[(v) => !!v && v.trim().length > 0 || 'Reason is required']"
                  required
              >
                <template slot="label">
                  Reason<RedAsterisk />
                </template>
              </v-text-field>
            </v-form>
          </div>
        </v-card-text>
        <v-card-actions class="pr-2">
          <v-spacer />
          <v-btn
            color="normal"
            class="mr-2"
            large
            @click="cancel"
          >
            <span style="font-size: 18px;">{{ cancelBtn }}</span>
          </v-btn>
          <v-btn
            v-if="showConfirmBtn"
            color="primary"
            large
            @click="confirm"
          >
            <span style="font-size: 18px;">{{ confirmBtn }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

import { mapState } from 'vuex';

export default {
  data: () => ({
    title: '',
    message: '',
    confirmationType: '',
    confirmBtn: 'Submit',
    showConfirmBtn: true,
    cancelBtn: 'Cancel',
    dialog: false,
    resolvePromise: undefined,
    rejectPromise: undefined,
    withReason: false,
    reason: null,
    header: 'Confirmation'
  }),
  computed: {
    messagePrefix() {
      switch (this.confirmationType) {
        case 'warning':
          return '*Warning: '
        case 'error':
          return '*Error: '
        default:
          return '';
      }
    },
  },
  mounted() {
    this.$bus.$on('confirm', this.open);
  },
  methods: {

    open(options = {}) {
      if (options.title) this.title = options.title;
      if (options.message) this.message = options.message;
      if (options.confirmationType) this.confirmationType = options.confirmationType;
      if (options.confirmBtn) this.confirmBtn = options.confirmBtn;
      if (options.cancelBtn) this.cancelBtn = options.cancelBtn;
      if (options.withReason) this.withReason = options.withReason;

      if (options.showConfirmBtn !== undefined) this.showConfirmBtn = options.showConfirmBtn;
      else this.showConfirmBtn = true;
      if (options.header) this.header = options.header;
      else this.header = 'Confirmation';
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },

    confirm() {
      if (this.withReason) {
        this.confirmWithReason();
        return;
      }
      this.reset();
      this.dialog = false;
      this.resolvePromise(true);
    },

    confirmWithReason() {
      if (!this.$refs.form.validate()) return;
      if (!this.reason || this.reason.trim().length === 0) {
        this.$bus.$emit('showError', 'Reason is required');
        return;
      }
      const reason = this.reason.trim();
      this.reset();
      this.dialog = false;
      this.resolvePromise(reason);
    },

    cancel() {
      this.reset();
      this.dialog = false;
      this.resolvePromise(false);
    },

    reset() {
      this.title = '';
      this.message = '';
      this.reason = null;
      this.withReason = false;
      this.confirmationType = '';
      this.showConfirmBtn = true;
      this.header = 'Confirmation'
    }
  },
};
</script>
<style scoped>
.message-warning {
  color: orange; 
}
.message-error {
  color: red; 
}
</style>